import { format } from "date-fns"
import { toQueryString } from "../../utils/parsers/QueryString"

export class SellerBalanceListFilterModel {
    balanceDate: Date = new Date()

    constructor(s?:Partial<SellerBalanceListFilterModel>) {
        Object.assign(this, s)
    }

    isFilterFilled():boolean {
        return !!this.balanceDate
    }

    toQueryString():string {
        const tmp = {
            ...this,
            balanceDate: format(this.balanceDate, 'yyyy-MM-dd'),
        }

        return toQueryString(tmp)
    }
}
